import React from "react";
import UnfoldMoreRounded from "@material-ui/icons/UnfoldMoreRounded";
import UnfoldLessRounded from "@material-ui/icons/UnfoldLessRounded";
import "./CategoryExpansionControls.css";

const CategoryExpansionControls = ({
  allExpanded = false,
  language = "english",
  noneExpanded = false,
  onSetAll,
}) => (
  <div
    aria-label={language === "arabic" ? "التحكم في الأقسام" : "Category sections"}
    className="sf-category-expansion"
    dir={language === "arabic" ? "rtl" : "ltr"}
    role="group"
  >
    <button type="button" disabled={allExpanded} onClick={() => onSetAll(true)}>
      <span><UnfoldMoreRounded aria-hidden="true" />
        {language === "arabic" ? "توسيع الكل" : "Expand all"}
      </span>
    </button>
    <button type="button" disabled={noneExpanded} onClick={() => onSetAll(false)}>
      <span><UnfoldLessRounded aria-hidden="true" />
        {language === "arabic" ? "طي الكل" : "Collapse all"}
      </span>
    </button>
  </div>
);

export default CategoryExpansionControls;
